// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import VoiceTutorController from "./voice_tutor_controller"
application.register("voice-tutor", VoiceTutorController)
